import { Button, Dropdown } from "react-bootstrap";
import "./itemprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import { ReactSVG } from "react-svg";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../utils/permissionUtils";

const ItemProfileHeader = ({
  selectedTypeData,
  updateStatus,
  toggleModal,
  duplicateType,
}: any) => {

  const isPermitted = useModulePermissions(PermissionModule.ITEM_TYPE_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_ITEM_TYPE);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_ITEM_TYPE);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_ITEM_TYPE);
  const isStatusChangePermitted = isPermitted(PermissionIdentifier.INACTIVE_ITEM_TYPE);
  const isAnyActionPermitted = isDeletePermitted || isDuplicatePermitted || isStatusChangePermitted;

  return (
    <div className="user-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedTypeData.rxTypeName}</h2>
        <div
          className={`status-box 
          ${selectedTypeData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedTypeData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-item-master">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {isAnyActionPermitted && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isStatusChangePermitted && (
              <Dropdown.Item onClick={updateStatus}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deactivateicon}
                />
                {selectedTypeData.isActive ? "Deactivate" : "Activate"}
              </Dropdown.Item>
            )}
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
            {isDuplicatePermitted && (
              <Dropdown.Item onClick={duplicateType}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={duplicateicon}
                />
                Duplicate
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default ItemProfileHeader;
